import chroma from "chroma-js";
function getVisualColor(bg, fg) {
  if (fg === "transparent") {
    fg = "#0000";
  }
  let visualColor = null;
  if (chroma.valid(fg)) {
    let fgAlpha = chroma(fg).alpha();
    let isFgOpaque = fgAlpha === 1;
    if (isFgOpaque) {
      visualColor = chroma(fg).hex();
    } else if (chroma.valid(bg)) {
      visualColor = chroma(bg).mix(chroma(fg).alpha(1), fgAlpha).hex();
    }
  }
  return visualColor;
}
export { getVisualColor as default };